.cu{padding:0.5rem;}